import { USERS_API_ENDPOINT } from "../../../constants/constant";
import baseApi from "../../baseApi";
import {
  ApiResponse,
  GraphDataType,
  ResultType,
  User,
  UserAnalytics,
  DistributeRewardParams,
} from "./user.type";

export interface UserQueryParams {
  search?: string;
  status?: string;
  isKol?: boolean;

  userType?: string;
  page?: number;
  limit?: number;
}

export const usersApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    addKol: build.mutation<ApiResponse, string>({
      query: (userId) => ({
        url: USERS_API_ENDPOINT.ADD_KOL,
        method: "PUT",
        body: { userId }, // or just userId if backend expects it directly
      }),
      invalidatesTags: ["Users"],
    }),
    getUsersAnalyticsApiCall: build.query<
      ApiResponse<UserAnalytics>,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        // if (params?.campaignId)
        //   queryParams.append("campaignId", params.campaignId);

        // if (params?.search) queryParams.append("search", params.search);
        // if (params?.status) queryParams.append("status", params.status);

        return `${USERS_API_ENDPOINT.GET_USERS_ANALYTICS}`;
      },
      providesTags: ["UsersAnalytics"],
    }),

    getUsersGraphAnalyticsApiCall: build.query<
      ApiResponse<GraphDataType[]>,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        // if (params?.campaignId)
        //   queryParams.append("campaignId", params.campaignId);

        // if (params?.search) queryParams.append("search", params.search);
        // if (params?.status) queryParams.append("status", params.status);

        return `${USERS_API_ENDPOINT.GET_GRAPH_DATA}`;
      },
      providesTags: ["UsersAnalytics"],
    }),

    getUsersApiCall: build.query<
      ApiResponse<ResultType<User>>,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.search) queryParams.append("search", params.search);
        if (params?.status) queryParams.append("status1", params.status);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());
        if (params?.isKol !== undefined) {
          queryParams.append("isKol", String(params.isKol));
        }
        return `${USERS_API_ENDPOINT.GET_USERS}?${queryParams.toString()}`;
      },
      providesTags: ["Users"],
    }),

    viewUserkApiCall: build.mutation<ApiResponse, any>({
      query: (userBody) => ({
        url: `${USERS_API_ENDPOINT.VIEW_USER}?userId=${userBody.userId}`,
        method: "GET",
      }),
      invalidatesTags: ["Tasks"],
    }),

    changeUsersStatusApiCall: build.mutation<ApiResponse, any>({
      query: (userBody) => ({
        url: `${USERS_API_ENDPOINT.CHANGE_USER_STATUS}?userId=${userBody.userId}`,
        method: "PUT",
      }),
      invalidatesTags: ["Users", "UsersAnalytics"],
    }),

    deleteUsersStatusApiCall: build.mutation<ApiResponse, any>({
      query: (userBody) => ({
        url: `${USERS_API_ENDPOINT.DELETE_USER}?userId=${userBody.userId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Users", "UsersAnalytics"],
    }),
    distributeRewardApiCall: build.mutation<
      ApiResponse,
      DistributeRewardParams
    >({
      query: ({ _ids, amount, hash, campaignId }) => ({
        url: `${USERS_API_ENDPOINT.DISTRIBUTE_REWARDS}`,
        method: "PUT",
        body: {
          _ids,
          amount,
          hash,
          campaignId,
        },
      }),
      invalidatesTags: ["Users", "UsersAnalytics"],
    }),
  }),
});

export const {
  useAddKolMutation,
  useGetUsersApiCallQuery,
  useLazyGetUsersApiCallQuery,
  useGetUsersAnalyticsApiCallQuery,
  useDeleteUsersStatusApiCallMutation,
  useChangeUsersStatusApiCallMutation,
  useGetUsersGraphAnalyticsApiCallQuery,
  useDistributeRewardApiCallMutation,
  //   useUpdateTaskApiCallMutation,
  //   useCreateTaskApiCallMutation,
  //   useChangeCampaignsTaskStatusApiCallMutation,
} = usersApiSlice;

export default usersApiSlice;
